import { ScanService } from '@nsftx/seven-client-retail-utils'
import { useIntegrator } from '@nsftx/seven-client-retail-vue-integrator'

let emitKeydownHandler: ((event: KeyboardEvent) => void) | null = null

const unbindEmitKeydown = () => {
  if (!emitKeydownHandler) {
    return
  }

  window.removeEventListener('keydown', emitKeydownHandler)
  emitKeydownHandler = null
}

const bindEmitKeydown = () => {
  const { emitDomEvent } = useIntegrator()
  unbindEmitKeydown()

  emitKeydownHandler = (e) => {
    if (ScanService().isScanActive()) {
      return
    }

    const eventData = {
      type: 'keydown',
      params: {
        key: e.key,
        code: e.code,
        location: e.location,
        altKey: e.altKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        shiftKey: e.shiftKey,
        repeat: e.repeat,
      },
    }
    emitDomEvent(eventData)
  }

  window.addEventListener('keydown', emitKeydownHandler)
}

export {
  bindEmitKeydown,
  unbindEmitKeydown
}
